import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface UsersFiltersState {
  id: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  banned?: boolean;
  tenantId?: string | null;
}

const initialState: UsersFiltersState = {
  id: "",
};

const usersFiltersSlice = createSlice({
  name: "usersFilters",
  initialState,
  reducers: {
    setId: (state, action: PayloadAction<string>) => {
      state.id = action.payload;
    },
    setEmail: (state, action: PayloadAction<string | undefined>) => {
      state.email = action.payload;
    },
    setFirstName: (state, action: PayloadAction<string | undefined>) => {
      state.firstName = action.payload;
    },
    setLastName: (state, action: PayloadAction<string | undefined>) => {
      state.lastName = action.payload;
    },
    setBanned: (state, action: PayloadAction<boolean | undefined>) => {
      state.banned = action.payload;
    },
    setTenantId: (
      state,
      action: PayloadAction<string | null | undefined>
    ) => {
      state.tenantId = action.payload;
    },
    resetUsersFilters: () => initialState,
  },
});

export const {
  setId,
  setEmail,
  setFirstName,
  setLastName,
  setBanned,
  setTenantId,
  resetUsersFilters,
} = usersFiltersSlice.actions;

export default usersFiltersSlice.reducer;
